import { cn } from '@/lib/utils';
import { Crown } from 'lucide-react';

export default function PremiumBadge({
  shouldShowHoverEffects,
}: {
  shouldShowHoverEffects: boolean;
}) {
  return (
    <div
      className={cn(
        'absolute top-4 left-4 bg-secondary text-primary py-1 rounded-full z-10 text-xs px-2 font-extrabold uppercase flex items-center gap-1',
        'transition-all duration-300 ease-out',
        shouldShowHoverEffects ? 'scale-105' : 'scale-100'
      )}
    >
      <Crown className="w-4 h-4" /> VERIFIED
    </div>
  );
}
